import { render } from "./DedicatedVirtualAccountForm.vue?vue&type=template&id=702458b2"
import script from "./DedicatedVirtualAccountForm.vue?vue&type=script&lang=js"
export * from "./DedicatedVirtualAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__